export default "__VITE_ASSET__a5dd2848__"